import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnLoader from "../toolbox/CgnLoader";
import ContentTop from "../root/ContentTop";
import CgnAlert from "../toolbox/CgnAlert";
import CgnDatatable from "../toolbox/CgnDatatable";
import CgnMessage from "../toolbox/CgnMessage";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import {  URL } from "../../redux/actions/constants";
import CgnBadge from "../toolbox/CgnBadge";
import noFotoMember from "../../images/no-foto-user.jpg";
import CgnButtonDropdown from "../toolbox/CgnButtonDropdown";

class CompanyList extends Component {
  state = {
    pageTitle: "Firma Listele",
    pageAddLink: "firma-ekle",
    pageUpdateLink: "firma-guncelle",
    pageDetailLink: "firma-detay",
    pageListLink: "firma-listele",
    breadcrumb: [{ text: "Firma", link: "#" }],
    isLoading: false,
    isDeleted: false,
    alertErrorMessage: "",
    companyList: [],
    cell: 0,
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    var statusType = 1; // 1 aktif ve pasiflerin ikisinide getirmesi için
    axios
      .get(URL + "/companies/getlist/" + statusType, config)
      .then((response) => {
        this.setState({
          companyList: response.data,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  }

  handleDelete = (guid) => {
    confirmAlert({
      title: CgnMessage.deleteQuestionTitle,
      message: CgnMessage.deleteQuestionMessage,
      buttons: [
        {
          label: CgnMessage.deleteQuestionYes,
          onClick: () => this.deleteItem(guid),
        },
        {
          label: CgnMessage.deleteQuestionNo,
        },
      ],
    });
  };

  async deleteItem(guid) {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const URLParam = "/companies/delete";
    const obj = {
      guid,
    };
    axios
      .post(URL + URLParam, obj, config)
      .then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  }

  thStyle = {
    width: "61px",
  };

  thStyle2 = {
    width: "96px",
  };

  tdStyle = {
    width: "250px",
  };

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row className="companyList" id="list">
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title={CgnMessage.alertErrorTitle}
                  text={this.state.alertErrorMessage}
                />
              )}
              <CgnDatatable
                data={this.state.companyList}
                title={this.state.pageTitle}
                columns={[
                  {
                    name: "Logo",
                    sortable: false,
                    width: "80px",
                    selector: (row) => (
                      <div>
                        {row.logo ? (
                          <img
                            alt={row.name}
                            src={row.logo}
                            className="rdt_image rounded"
                          />
                        ) : (
                          <img
                            alt={row.name}
                            src={noFotoMember}
                            className="rdt_image rounded"
                          />
                        )}
                      </div>
                    ),
                  },

                  {
                    name: "Firma Bilgileri",
                    sortable: false,
                    cell: (row) => {
                      var phone = row.phone,
                        maskPhone = `${phone.substring(0, 1)}  ${
                          "(" + phone.substring(1, 4) + ")"
                        } ${phone.substring(4, 7)} ${phone.substring(
                          7,
                          9
                        )} ${phone.substring(9, 11)}`;
                      return (
                        <Table className="table table-responsive ">
                          <tbody>
                            <tr>
                              <th style={this.thStyle}>Ad</th>
                              {/* <th className="colon">:</th> */}
                              <td colSpan={4} key={row.name}>
                                {row.name}
                              </td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>E-Mail</th>
                              {/* <th className="colon">:</th> */}
                              <td style={this.tdStyle}>{row.eMail}</td>
                              <th style={this.thStyle}>Telefon</th>
                              {/* <th className="colon">:</th> */}
                              <td>{maskPhone}</td>
                            </tr>
                          </tbody>
                        </Table>
                      );
                    },
                  },

                  {
                    selector: "status",
                    width: "110px",
                    padding: "0px",
                    sortable: false,
                    cell: (row) => {
                      if (row.status) {
                        return <CgnBadge color="success" text="Aktif" />;
                      } else {
                        return <CgnBadge color="danger " text="Pasif" />;
                      }
                    },
                  },

                  {
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                    cell: (row, cell) => (
                      <CgnButtonDropdown
                        label={"Yönet"}
                        className="mr-0"
                        color="primary"
                        items={[
                          {
                            text: CgnMessage.updateButton,
                            className: "dropDownBtn",
                            href: `/${this.state.pageUpdateLink}/${row.guid}`,
                          },
                          {
                            text: CgnMessage.detailButton,
                            className: "dropDownBtn",
                            href: `/${this.state.pageDetailLink}/${row.guid}`,
                          },
                          {
                            text: CgnMessage.deleteButton,
                            className: "dropDownBtn",
                            onClick: () => this.handleDelete(row.guid),
                          },
                        ]}
                      />
                    ),
                  },
                ]}
                loading={this.state.isLoading}
              />
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default CompanyList;
